// extracted by mini-css-extract-plugin
export default {"news":"NewsPage_news__rUNJK","news__title":"NewsPage_news__title__pW4dk","news__subtitle":"NewsPage_news__subtitle__UNQ-S","news__descr":"NewsPage_news__descr__SLtjm"};